import { Stack, type StackProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type React from "react";
import type { ICategory } from ".";

const PREFIX = "PaperCollapseStack";
export const paperCollapseClasses = {
  paperButton: `${PREFIX}-paperButton`,
  paperButtonUncontrolled: `${PREFIX}-paperButtonUncontrolled`,
  paperButtonOpen: `${PREFIX}-paperButtonOpen`,
  paperButtonDisabled: `${PREFIX}-paperButtonDisabled`,
  paperButtonContent: `${PREFIX}-paperButtonContent`,
  paperButtonTitle: `${PREFIX}-paperButtonTitle`,
  category: `${PREFIX}-category`,
  collapse: `${PREFIX}-collapse`,
};

interface IPaperCollapseStackProps extends StackProps {
  fullWidth: boolean;
  category?: ICategory;
}

export const PaperCollapseStack = styled<React.FC<IPaperCollapseStackProps>>(Stack, {
  shouldForwardProp: (prop) => prop !== "fullWidth" && prop !== "category",
})(({ theme, fullWidth, category }) => ({
  [`& .${paperCollapseClasses.paperButton}`]: {
    minHeight: "40px",
    width: fullWidth ? "100%" : "fit-content",
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    border: "none",
    padding: 0,
    transitionDelay: "300ms",
    transitionDuration: "0s",
    transitionProperty: "border-bottom-right-radius, border-bottom-left-radius",
    cursor: "pointer",
    [`&.${paperCollapseClasses.paperButtonUncontrolled}`]: {
      cursor: "default",
    },
    [`&.${paperCollapseClasses.paperButtonOpen}`]: {
      transitionDelay: "unset",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    [`&.${paperCollapseClasses.paperButtonDisabled}`]: {
      cursor: "unset",
      color: "unset",
      [`& .${paperCollapseClasses.paperButtonContent}`]: {
        color: theme.palette.disabled.main,
      },
    },
    [`& .${paperCollapseClasses.category}`]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(1),
      backgroundColor: category
        ? typeof category.iconBackgroundColor === "function"
          ? category.iconBackgroundColor(theme)
          : category.iconBackgroundColor
        : "unset",
    },
  },
  [`& .${paperCollapseClasses.paperButtonContent}`]: {
    flex: "1 1 auto",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    color: theme.palette.primary.main,
    [`& .${paperCollapseClasses.paperButtonTitle}`]: {
      alignItems: "center",
      gap: theme.spacing(1),
      marginRight: fullWidth ? "16px" : "72px",
    },
  },
  [`& .${paperCollapseClasses.collapse}`]: {
    borderRadius: 0,
  },
}));
